import { render, staticRenderFns } from "./Form9Layout.vue?vue&type=template&id=0b50562a&scoped=true"
import script from "./Form9Layout.vue?vue&type=script&lang=ts"
export * from "./Form9Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=0b50562a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50562a",
  null
  
)

export default component.exports